export class BGroupModel{
  id: number;
  description: string;
}
